import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Navigation, Car, MapPin, Phone, Printer } from 'lucide-react';
import './Locations.css';
import locationsHeroImg from '../../assets/ContactUsPictures/contactUsImg1.jpg';

const Locations = () => {
  return (
    <div className="locations-page">
      
      {/* Section 1: Hero  ---------------------------------------------------- */}
      <section 
        className="locations-hero-section" 
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.40), rgba(0, 0, 0, 0)), url(${locationsHeroImg})` }}
      >
        <Container className="h-100 d-flex align-items-center justify-content-center">
          <div className="locations-hero-content text-center text-white">
            <h1 className="locations-title mb-3">Locations</h1>
            <p className="locations-subtitle">We always welcome walk-ins</p>
            <div className="locations-divider mx-auto mb-3"></div>
          </div>
        </Container>
      </section>

      {/* Section 2: Interactive Map  ---------------------------------------- */}
      <section className="map-section-locations overflow-hidden">
        <iframe 
          title="Infiniti Maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.606822458448!2d-81.3468925!3d28.5515233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e770308c339591%3A0xc6f5f3e4ec919790!2s3218%20E%20Colonial%20Dr%20Suite%20F%2C%20Orlando%2C%20FL%2032803!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
          width="100%" 
          height="450" 
          style={{ border: 0, display: 'block' }} 
          allowFullScreen="" 
          loading="lazy"
        ></iframe>
      </section>

      {/* Section 3: Directions Grid ---------------------------------- */}
      <section className="directions-section py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="direction-main-title">Where are you coming from?</h2>
            <div className="small-blue-line mx-auto"></div>
          </div>

          <Row className="g-4">
            {/* From Kissimmee */}
            <Col lg={4}>
              <div className="direction-card h-100 shadow-sm">
                <div className="direction-icon-box">
                  <Navigation size={30} />
                </div>
                <h4>From Kissimmee</h4>
                <p>
                  Take John Young Parkway, North to Colonial Drive, turn right. Go approximately 5 miles. 
                  You will pass under the I-4 overpass, Keep going. Once you get to the Orlando Fashion Square Mall, 
                  make a right into the plaza where HH Gregg and Sports Authority are. 
                  We are located next to the Hot Yoga and UCF Business offices, right after the Party City.
                </p>
              </div>
            </Col>

            {/* From East Orlando */}
            <Col lg={4}>
              <div className="direction-card h-100 shadow-sm">
                <div className="direction-icon-box">
                  <Car size={30} />
                </div>
                <h4>From East Orlando</h4>
                <p>
                  Take 408 heading West, get off at Crystal Lake Road., turn right into the plaza 
                  onto Colonial landing plaza just before Colonial Drive. We will be towards the right.
                </p>
              </div>
            </Col>

            {/* From West Orlando */}
            <Col lg={4}>
              <div className="direction-card h-100 shadow-sm">
                <div className="direction-icon-box">
                  <Navigation size={30} className="rotate-90" />
                </div>
                <h4>From West Orlando</h4>
                <p>
                  Take 408 heading East, get off at Bumby Ave., turn left. Take Bumby Ave. to Colonial Drive, turn right. 
                  Once you get to the Orlando Fashion Square Mall, make a right into the plaza where HH Gregg and 
                  Sports Authority are. We are located next to the Hot Yoga and UCF Business offices, 
                  right after the Party City.
                </p>
              </div>
            </Col>
          </Row>

          {/* Adresa Bar na dnu */}
          <div className="address-bar-final mt-5 py-4 px-3 text-center shadow-sm">
            <Row className="align-items-center justify-content-center g-3">
              <Col md="auto" className="d-flex align-items-center justify-content-center">
                <MapPin className="text-primary me-2" size={20} />
                <span>3218 E. Colonial Drive Suite F Orlando, FL 32803</span>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Locations;